<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="提现类型" prop="type">
            <el-select style="width: 232px" v-model="searchForm.type" placeholder="请选择提现类型" filterable clearable>
              <el-option label="佣金提现" value="1"></el-option>
              <el-option label="保证金提现" value="2"></el-option>
              <el-option label="结算金提现" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现方式" prop="payType">
            <el-select style="width: 232px" v-model="searchForm.payType" placeholder="请选择提现方式" filterable clearable>
              <el-option label="微信" value="1"></el-option>
              <el-option label="支付宝" value="2"></el-option>
              <el-option label="银行卡" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option v-for="item in dictionaries.platform_withdrawl_status" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间" prop="createdTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核时间" prop="approvedTimeStart">
            <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="打款时间" prop="paymentTimeStart">
            <el-date-picker v-model="value3" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3 style="margin-bottom: 0; margin-top: 20px">列表数据</h3>
        <div>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFn">导出提现记录</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import common from '../../../mixins/common.js'
export default {
  mixins: [common],
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '平台提现', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_yongjin.png'),
          title: '平台佣金',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_jiesuan.png'),
          title: '平台结算金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_baozhengjin.png'),
          title: '保证金',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '平台提现', path: '', type: '0' }
        ]
      },
      list: [],
      loading: false,
      searchForm: {
        type: null, // 	提现类型1佣金提现 2保证金提现 3结算金提现
        payType: null, // 	
        status: null, // 	
        createdTimeStart: '', // 	
        createdTimeEnd: '', // 	
        approvedTimeStart: '', // 	
        approvedTimeEnd: '', // 	
        paymentTimeStart: '',
        paymentTimeEnd: '' // 	
      },
      value1: [],
      value2: [],
      value3: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', },
        { label: '提现时间', prop: 'createdTime', minWidth: '160' },
        { label: '提现类型', prop: 'typeLabel', minWidth: '120' },
        { label: '提现金额（元）', prop: 'applyMoney', minWidth: '140' },
        { label: '提现方式', prop: 'payTypeLabel', minWidth: '120' },
        {
          label: '提现账号', minWidth: '220',
          render: (h, scope) => {
            return (
              <div>
                <p style="text-align:left;">账号：{scope.row.account}</p>
                <p style="text-align:left;">名称：{scope.row.accountName}</p>
              </div>
            )
          }
        },
        { label: '提现手续费（元）', prop: 'handlingFee', minWidth: '150' },
        { label: '实际到账（元）', prop: 'receivedMoney', minWidth: '130' },
        {
          label: '状态', prop: 'statusLabel', minWidth: '80',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '已到账') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else if (scope.row.statusLabel == '待审核' || scope.row.statusLabel == '待打款' || scope.row.statusLabel == '打款中') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else if (scope.row.statusLabel == '已驳回' || scope.row.statusLabel == '打款失败') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        { label: '备注', prop: 'approveContent', minWidth: '120' },
        { label: '审核时间', prop: 'approvedTime', minWidth: '160' },
        { label: '打款时间', prop: 'paymentTime', minWidth: '150' },

      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false
    }
  },
  created() {
    this.getWithdrawlStatistics()
    this.getWithdrawlPageList()
  },
  methods: {
    exportFn() {
      this.exporting = true;
      if (this.value1) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      if (this.value2) {
        this.searchForm.approvedTimeStart = this.value2[0];
        this.searchForm.approvedTimeEnd = this.value2[1];
      } else {
        this.searchForm.approvedTimeStart = ''
        this.searchForm.approvedTimeEnd = ''
      }
      if (this.value3) {
        this.searchForm.paymentTimeStart = this.value3[0];
        this.searchForm.paymentTimeEnd = this.value3[1];
      } else {
        this.searchForm.paymentTimeStart = ''
        this.searchForm.paymentTimeEnd = ''
      }
      this.axios.post('/platforms/exportWithdrawlList', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (this.searchForm.status == '') {
        this.searchForm.status = null
      }

      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.searchForm.createdTimeStart = '';
        this.searchForm.createdTimeEnd = '';
        this.searchForm.approvedTimeStart = '';
        this.searchForm.approvedTimeEnd = '';
        this.searchForm.paymentTimeStart = '';
        this.searchForm.paymentTimeEnd = '';
        this.value1 = []
        this.value2 = []
        this.value3 = []
      }
      this.getWithdrawlPageList()
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getWithdrawlPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getWithdrawlPageList()
    },
    getWithdrawlPageList() {
      console.log(this.value1)
      if (this.value1) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      if (this.value2) {
        this.searchForm.approvedTimeStart = this.value2[0];
        this.searchForm.approvedTimeEnd = this.value2[1];
      } else {
        this.searchForm.approvedTimeStart = ''
        this.searchForm.approvedTimeEnd = ''
      }
      if (this.value3) {
        this.searchForm.paymentTimeStart = this.value3[0];
        this.searchForm.paymentTimeEnd = this.value3[1];
      } else {
        this.searchForm.paymentTimeStart = ''
        this.searchForm.paymentTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/platforms/getWithdrawlPageList', this.searchForm)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    getWithdrawlStatistics() {
      this.axios.get('/platforms/getWithdrawlStatistics')
        .then(res => {
          if (res.code == 0) {
            this.records[0].price = res.data.commission;
            this.records[1].price = res.data.settleMoney;
            this.records[2].price = res.data.earnestMoney;
          }

        })
    },
    todetail() {
      this.$router.push({
        name: 'userDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>

